var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { BNavItem, BBadge } from 'bootstrap-vue';
var NavItem = /** @class */ (function (_super) {
    __extends(NavItem, _super);
    function NavItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.staticSection = ['fuerenand', 'belvita', ''];
        return _this;
    }
    Object.defineProperty(NavItem.prototype, "isStaticPage", {
        get: function () {
            return this.staticSection.includes(window.location.pathname.split('/')[1]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavItem.prototype, "ariaLabel", {
        get: function () {
            var _this = this;
            if (this.$route.matched.some(function (_a) {
                var name = _a.name;
                return name === _this.route;
            })) {
                return {
                    "aria-current": "page",
                    "role": 'menuitem',
                    "aria-label": this.label + " - " + this.$t('sideNav._currentPage')
                };
            }
            return {
                "role": 'menuitem',
                "aria-label": this.label
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NavItem.prototype, "isHeading", {
        get: function () {
            var _this = this;
            if (this.$route.matched.some(function (_a) {
                var name = _a.name;
                return name === _this.route;
            })) {
                return !this.$slots.default;
            }
        },
        enumerable: false,
        configurable: true
    });
    NavItem.prototype.onMenuItemClick = function () {
        this.$root.$emit('hideShowMenuClass');
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], NavItem.prototype, "label", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], NavItem.prototype, "route", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], NavItem.prototype, "routeParams", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], NavItem.prototype, "badge", void 0);
    __decorate([
        Prop({
            default: 'side',
        }),
        __metadata("design:type", String)
    ], NavItem.prototype, "variant", void 0);
    __decorate([
        Prop({
            default: true,
        }),
        __metadata("design:type", Boolean)
    ], NavItem.prototype, "exact", void 0);
    NavItem = __decorate([
        Component({
            components: {
                BNavItem: BNavItem,
                BBadge: BBadge,
            },
        })
    ], NavItem);
    return NavItem;
}(Vue));
export default NavItem;
